const jzbApi = {
  jzb_flag: '/shop-witness-status', // 判断是否开通了见证宝 2021 11 04
  jzb_cropList: '/shop-corp-list',  //   公司下拉列表 2021 11 05
  jzb_accInfo: '/bindAcct/queryByShopId', // 获取账户信息
  jzb_personCode: '/witness/v2.0/acct/bind-union-pay', // 个人鉴权发送短信
  jzb_personBind: '/witness/v2.0/acct/check-code-union', // 个人鉴权
  jzb_businessCode: '/witness/bindRelateAcctSmallAmount', // 企业发送鉴权金额
  // jzb_businessCodeResult: '/witness/smallAmountTransferQuery', // 企业鉴权结果
  jzb_businessBind: '/witness/checkAmount', // 企业鉴权
  jzb_cardType: '/certificate/list', // 获取证件类型
  jzb_Bank: '/eiconBranch/list', // 总行
  jzb_BankTree: '/subbranch/list', // 支行

  jzb_cashCode: '/witness/applicationTextMsgDynamicCode', // 申请提现或支付短信动态码
  jzb_cashFee: '/witness/memberWithdrawCash', // 会员提现-支持手续费
  jzb_cashInfo: '/bindAcct/queryWithdraw', // 会员提现-支持手续费
  jzb_unbind: '/witness/unbindRelateAcct', // 解绑
  jzb_cashList: '/operationLog/list', // 会员提现-支持手续费
  jzb_transferDetail: '/operationLog/search', // 交易明细
  jzb_transferDetailExport: '/operationLog/export', // 交易明细导出
  jzb_transferDetailInfo: '/payableBySaleOrderNumber/', // 交易明细详情
  jzb_exportPayShopDepositLog: '/shopDeposit/exportPayShopDepositLog', // 见证宝-保证金操作日志导出
  jzb_queryPayShopDepositLog: '/shopDeposit/queryPayShopDepositLog', // 供应商保证金操作日志查询
  jzb_queryNotice: '/notice/queryNotice', // 见证宝-公告-条件查询
  jzb_provinceList: '/province/list', // 查询省级信息
  jzb_cityList: '/city/', // 查询市级信息
  jzb_bankAdditionalRecorded: '/witness/legal-person-information/bank-additional-recorded', // 查询补录信息
  jzb_supplementaryUrl: '/witness/acct/supplementary-url', // 获取补录地址
  r4gys_personInfoAuth: '/personal/auth/bank/info/auth', // 个人鉴权
  r4gys_companyInfoAuth: '/bank/account/replace', // 绑定银行卡
  r4gys_cashInfo: '/pay/acquire/supplier/corp/bank/info', //提现 获取页面相关信息
  r4gys_verifyCode: '/pay/send/withdraw/verify/code', //提现 发送验证码
  r4gys_withdraw: '/pay/apply/withdraw', //提现
  r4gys_getBank: '/infinity-yggdrasil/meta/bank', //总行列表
  r4gys_getBranchBank: '/infinity-yggdrasil/meta/bank/branch', //支行列表
  r4gys_getProvince: '/infinity-yggdrasil/meta/address/province', //省列表
  r4gys_getPersonalCheck: '/pay/personal/check', //对私-发送验证码
  r4gys_getPersonaBind: '/pay/personal/bind', //对私-绑定银行卡
  r4gys_enterpriseCheck: '/pay/enterprise/check', //对公-获取额度
  r4gys_enterpriseBind: '/pay/enterprise/bind', //对公-绑定银行卡
  r4gys_addressCity: '/infinity-yggdrasil/meta/address/city', //市列表
  r4gys_accountUnBind: '/pay/account/un-bind', // 解绑银行卡
  r4gys_corpList: '/pay/list/corp/by/supplierId', // 根据供应商id获取全部公司
  r4gys_settleTransaction: '/pay/list/settle/transaction', // 交易记录查询
  r4gys_settleTransactionDetail: '/pay/get/settle/transaction/detail', // 交易明细查询
  r4gys_exportSettleTransactionDetail: '/pay/export/settle/transaction/detail', // 导出交易明细
  r4gys_getBankInfo: '/pay/bank-info', // 获取银行卡信息
}
export default jzbApi
// 支行/cnapsBranch/list
// 银行类型：/eiconBranch/list
// 身份证：/certificate/list



// WEBPACK FOOTER //
// ./src/service/basic/jzbApiList.js